import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Row, Col, Form} from 'react-bootstrap'
import {useLocation, useNavigate} from "react-router-dom";
import {resetSendLettersNotices, sendLettersNotices} from "../../actions/LetterNoticesActions";
import Loader from "../../components/Loader";
import AlertModal from "../../components/AlertModal";
import ExcelGenerator from "../../components/ExcelGenerator";
import Send from "../Icons/Send";
import ExelFileUpload from "../ExelFileUpload";
import {EXEL_ERROR_TYPE, HR_ID_COLUMN, NAME_COLUMN} from "../../constants";
import ErrorModalWindow from "../Modals/ErrorModalWindow";
import {
    DOWNLOAD_USER_INFO,
    NO_FILL,
    SENT_TO_EMAIL,
    SENT_TO_ID,
    UPLOAD_USER_INFO
} from "../../constants/ExelUploadConstants";
import HTMLViewer from "../HTMLViewer";

function LettersPreviewExportTab(props) {
    const history = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [sentToList, setSentToList] = useState([]);
    const [sentToListEmail, setSentToListEmail] = useState([]);
    const [templateColumn, setTemplateColumn] = useState({
        letterTemplateId: "",
        title: "",
        descriptions: "",
        manualDynamicColumns: "",
    });
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    });
    const [fieldIsValid, setFieldIsValid] = useState({
        isTemplateCheckExcelValid: false
    });
    const [excelFileParsedData, setExcelFileParsedData] = useState([]);
    const [modalBody, setModalBody] = useState(null);
    const [modalHeader, setModalHeader] = useState(null);
    const [excelErrorModal, setExcelErrorModal] = useState(false);
    const [fieldData, setFieldData] = useState({
        isSignRequired: false,
    });
    const [submit, setSubmit] = useState(false);
    const [hasEmails, setHasEmails] = useState(false);
    const [excelHeaders, setExcelHeaders] = useState([]);
    const [generateExcelData, setGenerateExcelData] = useState([]);
    const getTeacherList = useSelector(state => state.getTeacherAssociate)
    const getTemplateColumnDetails = useSelector(state => state.getTemplateColumn)
    const {error, loading, template_column} = getTemplateColumnDetails

    const gotoLetters = () => {
        dispatch(sendLettersNotices(location.state?.templateId, template_column?.documentText, sentToList, sentToListEmail, fieldData.isSignRequired))
    }

    const sendLettersNoticesDetails = useSelector(state => state.sendLettersNotices)
    const { loadingSend } = sendLettersNoticesDetails

    useEffect(() => {
        if (sendLettersNoticesDetails.letters_notices === true) {
            dispatch(resetSendLettersNotices())
            history('/letters-notices', {
                state: {
                    name: "1",
                    "message": `Letters Sent Successfully to ${(location.state?.userList.length + location.state?.emails.length - location.state?.emailCheck.length)}/${location.state?.userList.length + location.state?.emails.length} teachers/associates`
                }
            })
        }
        if (sendLettersNoticesDetails.error) {
            setAlertModal({
                display: true,
                type: error,
                message: "Letters/Notices couldn't be added"
            })
        }
    }, [sendLettersNoticesDetails]);

    useEffect(() => {
        const templateColumn = getTemplateColumnDetails.template_column;
        let manualDynamicColumns = [
                ...templateColumn?.manualDynamicColumns || [],
                ...templateColumn?.customDynamicColumns || [],
        ]

        setFieldData({isSignRequired: !!templateColumn?.isSignRequired});

        if (!templateColumn <= 0) {
            setTemplateColumn({
                ...templateColumn,
                letterTemplateId: templateColumn.letterTemplateId,
                title: templateColumn.title,
                descriptions: templateColumn.descriptions,
                manualDynamicColumns: manualDynamicColumns || "",
                prismDynamicColumns: templateColumn.prismDynamicColumns || "",
            })
        }
    }, [getTemplateColumnDetails.template_column]);

    useEffect(() => {
        const userList = location.state?.userList;
        const emailList = location.state?.emails;
        const templateColumn = getTemplateColumnDetails.template_column;

        if ((userList?.length || emailList?.length) && templateColumn) {
            const prismDynamicColumns = (emailList?.length && templateColumn?.prismDynamicColumns?.length)
                ? templateColumn?.prismDynamicColumns
                    .map(item => item.columnName)
                : [];

            const generateExcelData = userList
                .filter(id => id !== 0)
                .map((id => {
                    const teacher = getTeacherList.teacher_list?.find(item => item.employee_ID === id);

                    const prismData = prismDynamicColumns?.reduce((acc, columnName) => {
                        acc[columnName] = NO_FILL;
                        return acc;
                    }, {});

                    return {
                        [NAME_COLUMN]: `${teacher?.employee_First_Name || 'N/A'} ${teacher?.employee_Last_Name || ''}`,
                        [HR_ID_COLUMN]: id,
                        ...prismData
                    }
                }));


            if (emailList?.length) {
                emailList.forEach(id => {
                    generateExcelData.push({
                        [NAME_COLUMN]: id,
                        [HR_ID_COLUMN]: id,
                    })
                })
            }

            let headers = [];

            if (
                templateColumn?.prismDynamicColumns?.length ||
                templateColumn?.manualDynamicColumns?.length ||
                templateColumn?.customDynamicColumns?.length
            ) {
                headers = [
                    ...prismDynamicColumns,
                    ...templateColumn?.manualDynamicColumns
                        .map(item => item.columnName),
                    ...templateColumn?.customDynamicColumns
                        .map(item => item.columnName)
                ]
            }

            setExcelHeaders(headers);
            setGenerateExcelData(generateExcelData);
        }
    }, [getTeacherList.teacher_list, getTemplateColumnDetails.template_column]);

    useEffect(() => {
        if (!templateColumn.letterTemplateId) {
            return;
        }

        const {prismDynamicColumns, manualDynamicColumns, customDynamicColumns} = templateColumn;
        const {userList, emails} = location.state;

        if (!manualDynamicColumns?.length
            && !customDynamicColumns?.length
            && prismDynamicColumns?.length
            && !emails.length
        ) {
            const userListIds = userList?.toString().split(',') || [];

            if (userListIds.length && !sentToList.length) {
                setDefaultRequestData(userListIds, SENT_TO_ID, setSentToList);
            }

            setSubmit(true);
        }

        if (!manualDynamicColumns?.length
            && !customDynamicColumns?.length
            && !prismDynamicColumns?.length
        ) {
            const userListIds = userList?.toString().split(',') || [];

            if (userListIds.length && !sentToList.length) {
                setDefaultRequestData(userListIds, SENT_TO_ID, setSentToList);
            }

            if (emails?.length && !sentToListEmail.length) {
                setDefaultRequestData(emails, SENT_TO_EMAIL, setSentToListEmail);
            }

            setSubmit(true);
        }
    }, [templateColumn]);

    const setDefaultRequestData = (userList, key, setValueFunc) => {
        userList?.forEach(id => {
            const newEntry = {
                [key]: id,
                dynamicColumns: [],
            };

            setValueFunc(prev => [...prev, newEntry]);
        })
    }

    const closeAlert = () => {
        setAlertModal({
            display: false
        })
    }

    const setIsSignatureRequired = () => {
        setFieldData({ ...fieldData, isSignRequired: !fieldData.isSignRequired });
    }

    const setExcelValidationModalInfo = ({type, error}) => {
        switch (type) {
            case EXEL_ERROR_TYPE.EmptyDynamicFields:
                setModalHeader('Error: Empty dynamic fields');
                setModalBody(
                    <div>
                        <div className="mb-2">{error}</div>
                        <p>Please, update the file and try uploading again.</p>
                    </div>
                );
                break;
            case EXEL_ERROR_TYPE.MissedValues:
                setModalHeader('Error: Missing values');
                setModalBody(
                    <div>
                        <p>The following required fields are missing or empty:</p>
                        <ul className="list-style-circle mt-2 mb-2">
                            {error.map((item, index) => (<li key={index}>{item}</li>))}
                        </ul>
                        <p>Please, update the file and try uploading again.</p>
                    </div>
                );
                break;
            case EXEL_ERROR_TYPE.HeaderError:
                setModalHeader('Error: Header mismatch');
                setModalBody(
                    <div>
                        <p>Custom dynamic fields in the template do not match those in the uploaded file:</p>
                        <div className="mt-2 mb-2">{error}</div>
                        <p>Please, update the file and try uploading again.</p>
                    </div>
                );
                break;
            case EXEL_ERROR_TYPE.IdsError:
                setModalHeader('Error: IDs mismatch');
                setModalBody(
                    <div>
                        <p>Selected users do not match those in the uploaded file:</p>
                        <div className="mt-2 mb-2">{error}</div>
                        <p>Please, update the file and try uploading again.</p>
                    </div>
                );
                break;
            default:
                return;
        }

        setExcelErrorModal(true);
    }

    const excelModalResult = () => {
        setExcelErrorModal(false);
    }

    useEffect(() => {
        if (fieldIsValid.isTemplateCheckExcelValid) {
            setSubmit(true)
        } else {
            if (!excelHeaders.length) {
                return
            }

            setSubmit(false)
        }
    }, [fieldIsValid.isTemplateCheckExcelValid, excelHeaders]);

    useEffect(() => {
        if (!excelFileParsedData.length) {
            return;
        }

        const {userList, emails} = location.state;

        if (userList?.length) {
            const excelFilePrismParsedData = excelFileParsedData.filter(item => userList.includes(item[HR_ID_COLUMN]));
            const prismUsersData = cleanedExcelFilePrismParsedData(excelFilePrismParsedData);

            setSentToList(transformExcelDataToRequest(prismUsersData, SENT_TO_ID));
        }

        if (emails?.length) {
            const excelFileEmailParsedData = excelFileParsedData.filter(item => emails.includes(item[HR_ID_COLUMN]));

            setSentToListEmail(transformExcelDataToRequest(excelFileEmailParsedData, SENT_TO_EMAIL));
        }
    }, [excelFileParsedData]);

    const cleanedExcelFilePrismParsedData = (excelFileParsedData) => {
        if (!excelFileParsedData?.length) {
            return;
        }

        return excelFileParsedData.map(obj => {
            const newObj = {};

            for (const [key, value] of Object.entries(obj)) {
                if (value !== NO_FILL) {
                    newObj[key] = value;
                }
            }
            return newObj;
        })
    };

    const transformExcelDataToRequest = (excelFileParsedData, requestKey) => {
        try {
            return excelFileParsedData.map(item => {
                const { Name, [HR_ID_COLUMN]: employeeId, ...dynamicData } = item;
                const dynamicColumns = Object.entries(dynamicData)
                    .map(([key, value]) => ({
                        columnName: key,
                        columnValue: value
                    }));

                return {
                    [requestKey]: employeeId,
                    dynamicColumns
                };
            });
        } catch (e) {
            return []
        }
    }

    return (
        <>
            {loading && <div class="loader-full-view"><Loader/></div>}
            {loadingSend && <div class="loader-full-view"><Loader/></div>}
            {alertModal.display &&
                <div class="modal-full-view">
                    <AlertModal heading={alertModal.message} type={alertModal.type} result={closeAlert}/>
                </div>
            }
            {excelErrorModal &&
                <div class="modal-full-view">
                    <ErrorModalWindow
                        heading={modalHeader}
                        result={excelModalResult}
                    >{modalBody}</ErrorModalWindow>
                </div>
            }
            <div>
                <p className="notice-preview-heading">
                    {templateColumn.title}
                </p>

                <div className="notice-preview-body">
                    {excelHeaders.length !== 0 ?
                        (<>
                            <div className="pb-4">
                                <div className="pt-3">{DOWNLOAD_USER_INFO}</div>
                                <ExcelGenerator
                                    headers={excelHeaders}
                                    data={generateExcelData}
                                    hasEmails={hasEmails}
                                />
                            </div>
                        </>)
                        :
                        <div className="pt-3">Don't need to import data, click to Send letters button to proceed</div>
                    }

                    <div>{UPLOAD_USER_INFO}</div>

                    <ExelFileUpload
                        customDymamicFields={excelHeaders}
                        selectedIds={[
                            ...(location.state?.userList?.filter(id => id !== 0) || []),
                            ...(location.state?.emails || [])
                        ]}
                        isDisabled={!excelHeaders.length}
                        setFieldIsValid={setFieldIsValid}
                        setExcelFileParsedData={setExcelFileParsedData}
                        setExcelValidationModalInfo={setExcelValidationModalInfo}
                    />

                    <div className="mb-2">
                        {template_column?.documentText && <HTMLViewer htmlContent={template_column?.documentText}/>}
                    </div>
                </div>

                <Row className="mt-4 button-size-25 background-1" style={{width: "100%"}}>
                    <Col lg={{span: 5}} md={{span: 5}}/>
                    <Col lg={{span: 4}} md={{span: 4}}>
                        <div className="mt-2">
                            <Form.Check
                                className="template-check"
                                name="new_template"
                                label="Require a signature for these letters?"
                                type="checkbox"
                                id="1"
                                checked={fieldData.isSignRequired}
                                onClick={() => setIsSignatureRequired()}
                            />
                        </div>
                    </Col>
                    <Col lg={{ span: 3 }} md={{ span: 3 }} className="padding-right-unset">
                        <div
                            className={`button-solid ${submit ? 'button-active' : 'button-inactive'}`}
                            onClick={submit ? gotoLetters : undefined}
                            style={{ cursor: submit ? 'pointer' : 'not-allowed' }}
                        >
                            <Send className="sidebar-icon" color="var(--white)" /> Send Letters
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
        ;
}

export default LettersPreviewExportTab;
